<script setup>
    import { ref, onMounted, watch } from 'vue'
    //import { useRoute, useRouter } from 'vue-router'
    //import DropDown from "@/components/common/DropDownSelect.vue"

    const version = __APP_VERSION__

    //properties set by parent
    const rowTypes = ref([])
    const columnHeaders = ref([])
    const parsedData = ref([])
    const activeIndex = ref(null);
    const activeType = ref(null);


    

    async function getTableData() {
        let path = '../json/changeLog.csv';
        //'http://localhost:5173/indicators/explorer/json/changeLog.csv'
        //console.log('path',path);
        let typeArray = [];
        const response = await fetch(path);
        const textData = await response.text(); // Get the response as a plain text string

        // Parse the header row
        const header = textData.split(/\r?\n|\r/, 1);
        columnHeaders.value = header[0].split(','); // Split header into columnHeaders array

        // Manually parse the CSV data
        const rows = textData.split(/\r?\n|\r/).slice(1); // Split into rows and remove the header row

        let i = 0
        rows.forEach(row => {
            const columns = row.split(','); // Split each row into columns
            if (columns.length > 1) { // Avoid processing empty lines
                const changeType = columns[0];
                const changeDate = new Date(columns[1]); // Convert strings to date
                //const datestring = date.toLocaleDateString() // Write date string to standard format
                const changeNote = columns[2];
                parsedData.value.push({id: i, type: changeType, date: changeDate, note: changeNote });
                typeArray.push(changeType);
            }
            i++
        });
        rowTypes.value = [...new Set(typeArray)];
        return true;
     
    }
    async function getTableJSON() {
        let path = '../json/changeLog.json';
        //'http://localhost:5173/indicators/explorer/json/changeLog.json'
        //console.log('path',path);
        let typeArray = [];
        const response = await fetch(path);
        const jsonData = await response.json(); // Get the response as json

        // Table headers
        // Ensure the array has at least one item
        if (jsonData.length > 0) {
            if (jsonData.length > 0) {
                columnHeaders.value = Object.keys(jsonData[0])
            }
            if(jsonData[0].ChangeType) {
                jsonData.forEach((object, index) => {
                    console.log('object',object)
                    const changeType = object.ChangeType;
                    const changeDate = new Date(object.Date); // Convert strings to date
                    const changeNote = object.Details;
                    parsedData.value.push({id: index, type: changeType, date: changeDate, note: changeNote });
                    typeArray.push(changeType);
                })
            }
        }
        rowTypes.value = [...new Set(typeArray)];
        return true;
     
    }
    function formatDate(d) {
        //var d = new Date(date),
        let month = '0' + (d.getMonth() + 1),
            day = '0' + d.getDate(),
            year = d.getFullYear();
        return [month.slice(-2), day.slice(-2), year].join('.');

    }
    function formatText(str) {
        return str.replaceAll('|','<br />').replaceAll(/%2c/gi,',');
    }
    function filterTable(type, index) {
        
        if(activeIndex.value == index) {
            activeIndex.value = null
            activeType.value = null;
        } else {
            activeIndex.value = index;
            activeType.value = type;
        }
    }
    onMounted(() => {
        //getTableData();
        getTableJSON();

        // Digital Analytics Program (https://digital.gov/guides/dap) 
        if(import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV === 'production') {
            const dapScript = document.createElement("script");
                dapScript.setAttribute("async", "")
                dapScript.setAttribute("id","_fed_an_ua_tag");
                dapScript.setAttribute("type","text/javascript");
                dapScript.setAttribute("src","https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=NSF");
            document.head.appendChild(dapScript);
        }
        
    })


</script>

<template>
    <section class="page-container">
        <div class="page-contents">
            <h2 class="title">Updates</h2>
            <div class="separator-line"></div>
            <p class="description">The following updates and corrections have been made to the Science and Engineering Indicators Explorer. To report an error, please send an email to 
				<a class="email_address" href="mailto:ncsesweb@nsf.gov">ncsesweb@nsf.gov</a>
			</p>

            <div class="chart-options-col222">
				<div class="start">
					<!-- put buttons here -->
                    <button 
                        v-for="(item, index ) in rowTypes" :key="index"
                        class="filterBttn"
                        :class="{ 'active-btn': activeIndex === index }" 
                        @click="filterTable(item, index)"                        
                    >
                            {{ item }}
                    </button>
				</div>
			</div>

            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th v-for="col in columnHeaders" :key="col">
                                {{ col }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in parsedData" :key="item.type" v-show="activeType === null || item.type === activeType">
                            <td class="ctype">{{ item.type }}</td>
                            <td>{{ formatDate(item.date) }}</td>
                            <td  v-html="formatText(item.note)"></td>
                        </tr>
                    </tbody>
                </table>
            </div>            
			<div class="table-container mobile">
				<table>
					<tbody>
					<template v-for="(item, index) in parsedData" :key="index">
						<tr v-for="col in columnHeaders" :key="col + '-' + index">
							<th scope="row">{{ col }}</th>
							<td v-if="col == 'ChangeType'">
								{{ item.type }}
							</td>
							<td v-else-if="col == 'Date'">
								{{ formatDate(item.date) }}
							</td>
							<td v-else-if="col == 'Details'">
								<span  v-html="formatText(item.note)"></span>
							</td>				
						</tr>
					</template>
					</tbody>
				</table>
            </div>
        </div>
    </section>
</template>

<style scoped>
.page-container {
     display: flex;
	flex-direction: column;
	flex-grow: 1;
	flex-shrink: 1;
  	min-width: 0;      /* Crucial for row layouts to allow shrinking */
  	min-height: 0;     /* Crucial for column layouts to allow shrinking */
    /*min-width: 375px;*/
    width: 100%;
    height: 100%;
    transition: max-width .2s linear;
    border-radius: 0.75rem;
    background-color: var(--surface-color-Default, #fff);
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);
    line-height: 1.5;
    background-color: var(--surface-color-Default, #fff);
}
.page-contents {
    padding: var(--spacing-7xl) var(--spacing-4xl) 0;
    margin-bottom: 1.5rem;
    min-height: 63vh;
}
.email_address {
    color: var(--text-Link);
    text-decoration: none;
}
.email_address:hover {
    text-decoration: underline;
}
.title {
    font-size: var(--font-size-H2);
    font-family: var(--font-family-Title, Roboto);
    font-weight: 500;
    color: var(--text-text-Header);
    line-height: var(--font-line-height-H2);
    margin: 0;
}
.separator-line {
    width: 5rem;
    height: 0.375rem;
    background-color: #005495;
    margin: 1.625rem 0;
}
.description {
    color: var(--text-Primary);
    font-family: var(--font-family-Title, Roboto);
    font-size: var(--font-size-Base);
    font-style: normal;
    font-weight: 400;
    line-height: var(--font-line-height-Base);
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;
    line-clamp: 7;
    align-self: stretch;
    max-width: 812px;
}
.subtle-label {
    color: var(--text-Secondary);
}
.filterBttn {
    height: 2.5rem;
    border-radius: 2rem;
    border-width: .1rem;
    border-style: solid;
    border-color: var(--brand-color-MedGrey);
    color: var(--brand-color-MedGrey);
    padding-top: 8px;
    padding-right: 20px;
    padding-bottom: 8px;
    padding-left: 20px;
    margin-right: 2rem;
    background-color: var(--input-background-Default);
    text-decoration: none;
}
.active-btn {
    border-color: var(--border-color-input-Active);
    color: var(--border-color-input-Active);
}
.table-container {
    margin-top: 2rem;
}
.table-container table {
  border-collapse: collapse; /* This is important to prevent double borders or gaps */
  width: 100%;
}
.table-container th {
    line-height: 1.5;
    background-color: var(--surface-color-Secondary);
    height: 2.6875rem;
    gap: .75rem;
    opacity: 1;
    padding-top: .25rem;
    padding-right: .5rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    border-bottom: 1px solid var(--border-color-input-Border); /* Sets the bottom border */
    text-align: left; /* Aligns text to the left */
}
.table-container td {
    line-height: 1.5;
    background-color: var(--surface-color-Default);
    height: 2.6875rem;
    gap: .75rem;
    opacity: 1;
    padding-top: .25rem;
    padding-right: .5rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    border-bottom: 1px solid var(--border-color-input-Border); /* Sets the bottom border */
    text-align: left; /* Aligns text to the left */
}
.ctype {
    white-space: nowrap;
}
.indicators-link {
    font-weight: 500;
    color: var(--brand-color-IndicatorsBlue);
    text-decoration: none;
}
.indicators-link i {
    font-size: larger;
}
.indicators-filesize {
    color: var(--text-Secondary);
    text-decoration: none;
    font-weight: 400;
    /*font-family: Roboto;*/
    font-weight: 400;
    font-size: .875rem;
    line-height: 1.25;
    letter-spacing: 0px;
}

.mobile {
	display: none;
}

/* 499px - Mobile phone */
@media (max-width: 31.1875rem) {
	.page-contents {
		padding: var(--spacing-5xl) var(--spacing-xl);
	}

	.table-container {
		display: none;
	}
	.mobile {
		display: block;
	}

 	.mobile tr > th:first-child, .mobile tr td:nth-child(2) {
		border-top: 1px solid var(--border-color-input-Border); 
	}
	.mobile tr:nth-child(3n) > th:first-child, .mobile tr:nth-child(3n) td:nth-child(2) {
		border-bottom: 3px solid var(--border-color-input-Border); 
	}
}
</style>